/* src/app/components/natPay/payroll-nat-pay-list/payroll-nat-pay-list.component.css */
.table-style {
  width: 100%;
}
.primary-btn {
  width: 100%;
  height: 2.571rem;
  color: #303030;
  background: #c7bcff;
  border-radius: 8px;
  border: 2px solid var(--Backgrounds-Primary, #3d0072);
  display: flex;
  padding: 4px 10px;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  font-size: 0.857rem;
  font-style: normal;
  font-weight: 700;
  transition: background-color 0.3s ease;
  box-sizing: border-box;
}
.primary-btn:hover {
  transition: background-color 0.3s ease;
  cursor: pointer;
  background-color: #303030;
  color: #ffffff;
  filter: invert(0);
}
.primary-btn:hover > .onemore {
  transition: background-color 0.3s ease;
  cursor: pointer;
  color: #ffffff;
}
/*# sourceMappingURL=payroll-nat-pay-list.component-YIHVP5B5.css.map */
